import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { CTASection } from "../components/Sections";
import { Reveal, Overline } from "../components/Reveal";
import { IMAGES } from "../data/config";

export default function SeasonalWorkers() {
  const { t } = useTranslation();
  const cycle = t("seasonal.cycle", { returnObjects: true });
  return (
    <>
      <PageHero
        overline={t("seasonal.overline")}
        title={<>{t("seasonal.titleA")} <span className="text-health">{t("seasonal.titleAccent")}</span></>}
        subtitle={t("seasonal.subtitle")}
        image={IMAGES.seasonal}
        accent="health"
        testId="seasonal-hero"
      />

      <section className="py-20 border-t border-white/5">
        <div className="container-x">
          <Reveal>
            <Overline color="health">{t("seasonal.cycleOverline")}</Overline>
            <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl tracking-tight max-w-2xl">{t("seasonal.cycleTitle")}</h2>
            <div className="mt-10 flex flex-wrap items-center gap-3">
              {cycle.map((leg, i) => (
                <React.Fragment key={i}>
                  <span className="px-4 py-2.5 rounded-lg bg-navy-700 border border-health/30 text-sm">{leg}</span>
                  {i < cycle.length - 1 && <ArrowRight size={16} className="text-health/60 rtl:rotate-180" />}
                </React.Fragment>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <CTASection title={t("seasonal.ctaTitle")} subtitle={t("seasonal.ctaSub")} ctaLabel={t("seasonal.ctaLabel")} ctaTo="/quote?plan=seasonal&cycle=A" variant="primary" testId="seasonal-cta" />
    </>
  );
}
